import {Box} from "@mui/material";
import {
    faAward,
    faChartPieSimple,
    faClipboardCheck,
    faFileMagnifyingGlass,
    faFlagCheckered,
    faRepeat,
    faScreenUsers
} from "@fortawesome/pro-duotone-svg-icons";
import JournalMetric from "@/src/components/main-site/home/slider/journal-metrics/journal-metric/journal-metric";

const JournalMetrics = ({journal}: { journal: any }) => (
    <Box sx={{display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', gap: '2px', mt: 1}}>
        {journal.meta_data?.if_score && (
            <JournalMetric
                icon={faAward}
                label="Impact Factor (JCR, Web of Sciences)"
                value={journal.meta_data?.if_score}
            />
        )}
        {journal.meta_data?.citation_score && (
            <JournalMetric
                icon={faAward}
                label="CiteScore"
                value={journal.meta_data?.citation_score}
            />
        )}
        {journal.meta_data?.frequency && (
            <JournalMetric
                icon={faRepeat}
                label="Frequency"
                value={journal.meta_data?.frequency}
            />
        )}

        {journal.meta_data?.journal_custom_field_3 && (
            <JournalMetric
                icon={faClipboardCheck}
                label="Time to First Decision (days)"
                value={journal.meta_data?.journal_custom_field_3}
            />
        )}
        {journal.meta_data?.review_time && (
            <JournalMetric
                icon={faScreenUsers}
                label="Review Time"
                value={journal.meta_data?.review_time}
            />
        )}
        {journal.meta_data?.publication_time && (
            <JournalMetric
                icon={faFlagCheckered}
                label="Accept to Publish (days)"
                value={journal.meta_data?.publication_time}
            />
        )}
        {journal.meta_data?.acceptance_rate && (
            <JournalMetric
                icon={faChartPieSimple}
                label="Acceptance Rate (%)"
                value={journal.meta_data?.acceptance_rate}
            />
        )}
        {journal.meta_data?.open_peer_review && (
            <JournalMetric
                icon={faFileMagnifyingGlass}
                label="Open Peer-Reviewed Articles"
                value={journal.meta_data?.open_peer_review}
            />
        )}
        {journal.meta_data?.acceptance_fee && (
            <JournalMetric
                icon={faFileMagnifyingGlass}
                label="Article Processing Charge (from)"
                value={journal.meta_data?.acceptance_fee}
            />
        )}
    </Box>
);

export default JournalMetrics;
